import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { AssignmentPermissions, DashboardPermissionsCellRendererParams } from 'src/AngularJS/Dashboard/dashboard-assignment.model';

@Component({
    selector: 'cv-dashboard-assignment-permissions-renderer',
    templateUrl: './dashboard-assignment-permissions-renderer.component.html',
    styleUrls: ['./dashboard-assignment-permissions-renderer.component.scss']
})
export class DashboardAssignmentPermissionsRendererComponent implements AgRendererComponent {
    AssignmentPermissions = AssignmentPermissions;
    value: AssignmentPermissions;
    private params: DashboardPermissionsCellRendererParams;

    constructor() { }

    agInit(params: DashboardPermissionsCellRendererParams) {
        this.value = params.value;
        this.params = params;
    }

    refresh(params: DashboardPermissionsCellRendererParams) {
        this.value = params.value;
        this.params = params;
        return true;
    }

    onValueChange() {
        this.params.setValue(this.value);
        this.params.permissionChanged?.emit(this.value);
    }
}
